import React from 'react';

export type AccordionContextProps = {
  expansion: Record<string, boolean>;
  toggleExpansion: (accordionId: string) => void;
};

export const AccordionContext = React.createContext<AccordionContextProps>(
  {} as AccordionContextProps
);
